import { render, staticRenderFns } from "./customJewelry.vue?vue&type=template&id=c57f07fe&scoped=true"
import script from "./customJewelry.vue?vue&type=script&lang=js"
export * from "./customJewelry.vue?vue&type=script&lang=js"
import style0 from "./customJewelry.vue?vue&type=style&index=0&id=c57f07fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57f07fe",
  null
  
)

export default component.exports